"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataGridNotification = void 0;
const react_1 = require("react");
const createNotification_1 = require("./helpers/createNotification");
function useDataGridNotification() {
    const [notificationContent, setNotificationContent] = (0, react_1.useState)(null);
    const [canClose, setCanClose] = (0, react_1.useState)(true);
    const didCloseHandlerListRef = (0, react_1.useRef)([]);
    const dismissNotification = () => {
        setNotificationContent(null);
        const didCloseHandlers = didCloseHandlerListRef.current;
        didCloseHandlerListRef.current = [];
        didCloseHandlers.forEach((cb) => cb());
    };
    return {
        notificationContent,
        showNotification(config) {
            setNotificationContent((0, createNotification_1.createNotification)(config));
            if (config.onDidClose) {
                didCloseHandlerListRef.current.push(config.onDidClose);
            }
            if (typeof config.canClose === 'boolean') {
                setCanClose(config.canClose);
            }
        },
        canCloseNotification: canClose,
        dismissNotification
    };
}
exports.useDataGridNotification = useDataGridNotification;
//# sourceMappingURL=hooks.js.map